export const enClientPortalValuationPlausibilityHeaderBar = {
    draftWithVersion: 'Draft {{version}}',
    options: {
        editObservers: 'Edit observers',
        stopObservingOrder: 'Stop observing order',
        observeOrder: 'Observe order',
    },
    emptyObserversMessage: 'No one is currently observing this order.',
    observers: {
        header: {
            protectedTooltip: 'As an order assignee, you automatically observe this order.',
            platformUserTooltip: 'Platform users cannot add themselves as observers.',
            observingTooltip: 'You are observing this order. Click to stop observing.',
            notObservingTooltip: 'You are not observing this order. Click to observe it.',
            addObserverTooltip: 'Add observers',
            observerGroup: 'Observers',
            disableObservationAriaLabel: 'Disable observing',
            enableObservationAriaLabel: 'Enable observing',
        },
        drawer: {
            title: 'Edit observers',
            addObserversLabel: 'Add more observers...',
            observeOrder: 'Observe order',
            observerCount_one: '{{count}} order observer',
            observerCount_other: '{{count}} order observers',
            editObservers: 'Edit observers',
            responsible: 'Assignee',
            responsibleRemoveTooltip: 'Order assignees cannot be removed as observers.',
            infoTitle: 'What are observers?',
            infoText:
                'Observers receive email updates about all order news enabled in their notification settings. This includes order status changes, available drafts, new messages, and task updates.',
            notificationSettings: 'Go to notification settings',
        },
    },
    userLink: {
        me: 'Me',
        external: 'External',
        unknown: 'Not set',
        unavailable: 'User unavailable',
        contact: 'Contact',
        editOwnContactTooltip: 'Edit own contact details',
        emailCopied: 'Email address copied',
        phoneCopied: 'Phone number copied',
        addressCopied: 'Address copied',
        note: 'Note',
        externalEmailInfo: 'This contact collaborates by email.',
    },
}
